exports["UK"] = require("./UK.js");
exports["IE"] = require("./IE.js");
exports["MT"] = require("./MT.js");